import AppColors, { black, primaryColors } from '~components/theme/styles/colors';

export const thinScrollBarSx = {
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: black['45%'],
    borderRadius: 8,
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 5,
    backgroundColor: primaryColors[800],
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: AppColors.primary[3],
  },
};
